import { Sizes } from '../types';
import { maxContentWidth } from '../layout';

export const sizes: Sizes = {
  maxContentWidth,
};
